import React from 'react';
import { Card, Tag } from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClock, faCalendarAlt, faBell } from "@fortawesome/free-solid-svg-icons";
import { formatDateTime, formatDateTimeFromNow } from '../../../../utils/functions';
import SOURCES from '../../../../utils/constants';

import { useHistory } from 'react-router-dom';

const EnhancedNotificationsCardView = ({
    record,
    onCardClick,
    onMarkAsRead
}) => {
    const history = useHistory();
    const isUnread = record.readStatus === SOURCES.NOTIFICATION_UNREAD;

    const handleCardClick = () => {
        if (record.isCustom) {
            history.push(record.link);
        } else {
            onCardClick && onCardClick(record);
        }
    }

    return (
        <Card
            hoverable
            className={`h-full relative ${isUnread ? '!border-primary' : ''}`}
            onClick={handleCardClick}
            style={{ padding: '0', display: 'flex', flexDirection: 'column', height: '100%' }}
        >
            <div className="flex-1">
                <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center gap-2 text-primary font-medium">
                        <FontAwesomeIcon icon={faBell} />
                        <span className="text-xs uppercase tracking-wider">Notification</span>
                    </div>
                    {isUnread ? (
                        <div
                            className={`cursor-pointer text-primary hover:text-primary-dark transition-colors ${record.isCustom ? 'opacity-30 cursor-not-allowed' : ''}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!record.isCustom) onMarkAsRead(record);
                            }}
                            title={record.isCustom ? "Cannot mark as read" : "Mark as Read"}
                        >
                            <FontAwesomeIcon icon={faCheck} className="mr-1" />
                            <span className="text-xs font-semibold">Mark Read</span>
                        </div>
                    ) : (
                        <Tag color="success" className="m-0">Read</Tag>
                    )}
                </div>

                <div className="mb-4">
                    <p className="text-sm text-gray-800 line-clamp-3 mb-0" style={{ wordBreak: 'break-word' }}>
                        {record.notifyText}
                        {record.isCustom && (
                            <span className="ml-2 text-xs text-primary font-medium underline">
                                {record.actionText}
                            </span>
                        )}
                    </p>
                </div>
            </div>

            <div className="mt-auto border-t border-gray-100 pt-3 flex items-center justify-between text-xs text-gray-500">
                <div className="flex items-center gap-1" title={formatDateTime(record.createdAt)}>
                    <FontAwesomeIcon icon={faCalendarAlt} />
                    <span>{formatDateTime(record.createdAt).split(' ')[0]}</span>
                </div>
                <div className="flex items-center gap-1">
                    <FontAwesomeIcon icon={faClock} />
                    <span>{formatDateTimeFromNow(record.createdAt)}</span>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedNotificationsCardView;
